function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "3.061617e-15%",
  id: "a"
}, React.createElement("stop", {
  stopColor: "#C8C8C8",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#979797",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-713.000000, -281.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(713.000000, 222.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, 59.000000)"
}, React.createElement("g", null, React.createElement("circle", {
  fill: "url(#a)",
  opacity: 0.5,
  cx: 20,
  cy: 20,
  r: 20
}), React.createElement("path", {
  d: "M27.6383691,14.3050445 C28.0221825,13.9079226 28.6552555,13.8971339 29.0523774,14.2809473 C29.4494993,14.6647606 29.4602879,15.2978337 29.0764746,15.6949555 L18.6390188,26.4943245 C18.2459232,26.9010505 17.5940089,26.9010505 17.2009133,26.4943245 L11.2809473,20.3690869 C10.8971339,19.971965 10.9079226,19.3388919 11.3050445,18.9550786 C11.7021663,18.5712653 12.3352394,18.582054 12.7190527,18.9791758 L17.919966,24.360428 L27.6383691,14.3050445 Z",
  fill: "#FFFFFF"
}))))));

const SvgDoneDeselectedIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgDoneDeselectedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/done-deselected-icon.234a4c23.svg";
export { ForwardRef as ReactComponent };